(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zep-contextual-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zep-contextual-recommendations')) {
    customElements.define('zep-contextual-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.loadRecommendations('complementary');
        }, { rootMargin: '0px 0px 500px 0px' });
        this.observer.observe(this);
      }

      async loadRecommendations(intent) {
        try {
          const response = await fetch(`${this.dataset.url}&intent=${intent}`);
          if (!response.ok) throw new Error('Recommendation request failed');
          const html = document.createElement('div');
          html.innerHTML = await response.text();
          const content = html.querySelector('[data-zep-recommendation-content]');

          if (!content && intent === 'complementary') {
            await this.loadRecommendations('related');
            return;
          }

          if (!content) {
            this.remove();
            return;
          }

          this.innerHTML = content.outerHTML;
          const cards = [...this.querySelectorAll('.zep-contextual-recommendations__card')];
          if (!cards.length) {
            this.remove();
            return;
          }
          this.dataset.productCount = String(cards.length);
          const controls = this.querySelector('.zep-contextual-recommendations__controls');
          if (controls) controls.hidden = cards.length < 2;
          const title = this.querySelector('.zep-contextual-recommendations__title');
          if (title) {
            title.textContent = intent === 'complementary' ? this.dataset.complementaryTitle : this.dataset.relatedTitle;
          }
          this.hidden = false;
          this.initializeCarousel();
        } catch (error) {
          if (intent === 'complementary') {
            this.loadRecommendations('related');
          } else {
            this.remove();
          }
        }
      }

      initializeCarousel() {
        const track = this.querySelector('[data-zep-carousel-track]');
        const previous = this.querySelector('[data-zep-carousel-prev]');
        const next = this.querySelector('[data-zep-carousel-next]');
        if (!track || !previous || !next) return;

        const move = (direction) => {
          const card = track.querySelector('.zep-contextual-recommendations__card');
          const distance = card ? card.getBoundingClientRect().width + 15 : track.clientWidth * 0.8;
          track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
